/**
 * Blog covers are authored as `/blog/<slug>/cover.jpeg` (also used for og:image / RSS).
 * Lightweight WebP renditions sit next to them: cover-800.webp and cover-1600.webp.
 * Returns srcset data for <img>, or null when the cover is not a standard post cover.
 */
export function coverSources(cover: string | undefined) {
	if (!cover) return null;
	const m = cover.match(/^(\/blog\/[^/]+)\/cover\.jpe?g$/);
	if (!m) return { src: cover, srcset: undefined };
	return {
		src: `${m[1]}/cover-800.webp`,
		srcset: `${m[1]}/cover-800.webp 800w, ${m[1]}/cover-1600.webp 1600w`
	};
}
